export default __webpack_public_path__ + "static/media/notesIcon.2af90537.svg";